import { NgModule } from '@angular/core';
import { CryptoJsService } from './crypto-js.service';
import { RegistryService } from './registry.service';
import { RsaEncryptService } from './rsa-encrypt.service';
import { StorageService } from './storage.service';

@NgModule({
  providers: [
    CryptoJsService,
    RsaEncryptService,
    StorageService,
    RegistryService
  ],
})
export class UtilsModule {}
